import React from 'react';

import {
  Slide,
  SlideGroupName,
  usePitchDesignSectionQuery
} from 'generated/graphql';
import _ from 'lodash';
import {
  pitchDeckUtil,
  useLoading
} from 'modules';



interface PitchDesignSectionData {
  id: Slide['id'];
  title: Slide['title'];
  thumbnailId: Slide['thumbnail']['id'];
}

type PitchDesignSectionDataCollection = {
  [key in SlideGroupName]: PitchDesignSectionData[];
}

export function usePitchDesignSection() {
  const tuple = usePitchDesignSectionQuery({ fetchPolicy: 'cache-first' });
  const loading = useLoading([tuple]);

  const data = React.useMemo((): PitchDesignSectionDataCollection => {
    const apiData = tuple.data?.slides ?? [];

    const collection: PitchDesignSectionDataCollection = {
      bySlideType: [],
      byPitchExample: [],
      otherResources: []
    };

    for (let i = 0; i < apiData.length; i += 1) {
      const groupName = apiData[i].slideGroup.name;
      const thumbnailFileName = apiData[i].thumbnail.fileName;

      if (pitchDeckUtil.displayingThumbnails[groupName].includes(thumbnailFileName)) {
        collection[groupName].push({
          id: apiData[i].id,
          title: apiData[i].title,
          thumbnailId: apiData[i].thumbnail.id
        });
      }
    }

    return {
      bySlideType: _.sortBy(collection.bySlideType, col => pitchDeckUtil.getRankingFromTitle(col.title)),
      byPitchExample: _.sortBy(collection.byPitchExample, col => pitchDeckUtil.getRankingFromTitle(col.title)),
      otherResources: _.sortBy(collection.otherResources, col => pitchDeckUtil.getRankingFromTitle(col.title))
    };

  }, [tuple.data?.slides]);

  const groupName: { [key in SlideGroupName]: string } = {
    bySlideType: 'By Slide Type',
    byPitchExample: 'By Pitch Example',
    otherResources: 'Other Resources'
  };

  return {
    loading,
    data,
    groupName
  };
}
